import { client } from "../../../../Infrastructure/agent";

export const highlightService = {
  save: (highlight) => client.post("/Highlight/save", { highlight }),
  getHighlightByWeek: (week, assetId) =>
    client.post("/Highlight/load", {
      assetId: Number(assetId),
      week: Number(week),
    }),
};

